import React from "react";
import mainImg from "../acepts/uzb_img1.jpg";
import "./video.css";
import Logo from "../acepts/tahlil.svg";
import { NavLink } from "react-router-dom";
export const videoData = [
  {
    id: 1,
    title: "O'zbekistan",
    img: "https://www.youtube.com/embed/XH1aXNIpK4s",
    desk: "Фарғона водийсида илк бор ягона корпоратив бошқарув, ягона стратегия, ягона кузатув кенгашига қаратилган бизнес тармоқлари MARAFON номи остида бирлашди.",
  },
];

export const photo = [
  {
    id: 2,
    title: "O'zbekistan",
    img: mainImg,
    desk: "Фарғона водийсида илк бор ягона корпоратив бошқарув, ягона стратегия, ягона кузатув кенгашига қаратилган бизнес тармоқлари MARAFON номи остида бирлашди.",
  },
];

function Video(props) {
  return (
    <>
      <div className="col-md-6">
        <div className="video_title pb-3">
          <div className="video_title_text d-flex align-items-center">
            <img src={Logo} alt="Error img" />
            <h3 className="ms-2">Video news</h3>
          </div>
          <h5 className="link_news"><NavLink to="/videoPage">All News <i class="bi bi-arrow-right ms-2"></i></NavLink></h5>
        </div>
        {videoData.map((video) => (
          <div key={video.id} className="card cart_video mb-1" data-aos="fade-up">
            <iframe
              src={video.img}
              title="Bootstrapda website yasash"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              controls
            ></iframe>
            <div className="card-body">
              <div className="video_text">
                <h5 className="card-title">{video.title}</h5>
                <small className="fs-6 ms-4">
                  2022.06.20 <span className="ms-3">17:14</span>
                </small>
              </div>
              <p className="card-text">{video.desk}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="col-md-6 photo">
        <div className="video_title pb-3">
            <div className="video_title_text  d-flex align-items-cente">
            <img src={Logo} alt="Error img" />
            <h3 className="ms-2">Photo news  </h3>
            </div>
            <h5 className="link_news"><NavLink to="/photo">All News <i class="bi bi-arrow-right ms-2"></i></NavLink></h5>
        </div>
        {photo.map((photo) => (
          <div key={photo.key} className="card cart_photo mb-1" data-aos="fade-up">
            <img src={photo.img} alt="Error img" />
            <div className="card-body">
              <div className="video_text">
                <h5 className="card-title">{photo.title}</h5>
                <small className="fs-6 ms-4">
                  2022.06.20 <span className="ms-3">17:14</span>
                </small>
              </div>
              <p className="card-text">{photo.desk}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Video;
